'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _colors = require('HubStyleTokens/colors');

var _UICheckmark = require('../icon/icons/UICheckmark');

var _UICheckmark2 = _interopRequireDefault(_UICheckmark);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CHECKBOX_REF = 'checkbox';

var SIZE_CLASSES = {
  default: '',
  small: 'private-form__toggle-switch--sm',
  'extra-small': 'private-form__toggle-switch--xs'
};

var UIToggle = _react2.default.createClass({
  displayName: 'UIToggle',

  propTypes: {
    checked: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    I18n: _react.PropTypes.object,
    id: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    onClick: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)).isRequired,
    textChecked: _react.PropTypes.node,
    textUnchecked: _react.PropTypes.node,
    use: _react.PropTypes.oneOf(['default', 'on-dark'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'default',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        checked = _props.checked,
        defaultChecked = _props.defaultChecked;

    return {
      checked: checked || defaultChecked || false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var checked = _ref.checked;

    if (checked !== this.state.checked) {
      this.setState({ checked: checked });
    }
  },
  handleChange: function handleChange(evt) {
    var _props2 = this.props,
        disabled = _props2.disabled,
        onChange = _props2.onChange,
        readOnly = _props2.readOnly;
    var checked = evt.target.checked;


    if (disabled || readOnly) {
      evt.preventDefault();
      return;
    }

    if (!this.props.hasOwnProperty('checked')) {
      this.setState({ checked: checked });
    }

    (0, _Functions.callIfPossible)(onChange, evt);
  },
  getLabelClassName: function getLabelClassName(_ref2) {
    var className = _ref2.className,
        disabled = _ref2.disabled,
        readOnly = _ref2.readOnly,
        size = _ref2.size,
        textChecked = _ref2.textChecked,
        textUnchecked = _ref2.textUnchecked,
        use = _ref2.use;

    var hasCustomText = textChecked || textUnchecked;
    return (0, _reactUtils.classNames)('uiToggle', 'private-form__toggle-switch', className, SIZE_CLASSES[size], {
      'private-form__toggle-switch--disabled': readOnly || disabled,
      'private-form__toggle-switch--customized-text': hasCustomText,
      'private-form__toggle-switch--on-dark': use === 'on-dark'
    });
  },
  getSwitchClassName: function getSwitchClassName() {
    return (0, _reactUtils.classNames)('uiToggleSwitch', 'private-form__toggle-switch__inner', {
      'uiToggleSwitchOn private-form__toggle-switch--on': !!this.state.checked
    });
  },
  renderCheckedIndicator: function renderCheckedIndicator() {
    return _react2.default.createElement(_UICheckmark2.default, {
      className: 'private-form__toggle-switch__icon',
      fill: _colors.CALYPSO,
      stroke: _colors.OLAF,
      strokeWidth: 2
    });
  },
  renderToggleLabel: function renderToggleLabel(text, className) {
    return _react2.default.createElement(
      'span',
      {
        className: (0, _reactUtils.classNames)('uiToggleSwitchLabel', 'private-form__toggle-switch__label', className)
      },
      text
    );
  },
  renderToggleLabelChecked: function renderToggleLabelChecked(_ref3) {
    var I18n = _ref3.I18n,
        textChecked = _ref3.textChecked;

    var text = textChecked || I18n.text('salesUI.UIToggle.checkedLabel');
    return this.renderToggleLabel(text, 'private-form__toggle-switch__label--checked');
  },
  renderToggleLabelUnchecked: function renderToggleLabelUnchecked(_ref4) {
    var I18n = _ref4.I18n,
        textUnchecked = _ref4.textUnchecked;

    var text = textUnchecked || I18n.text('salesUI.UIToggle.uncheckedLabel');
    return this.renderToggleLabel(text, 'private-form__toggle-switch__label--unchecked');
  },
  render: function render() {
    var _props3 = this.props,
        checked = _props3.checked,
        className = _props3.className,
        defaultChecked = _props3.defaultChecked,
        disabled = _props3.disabled,
        I18n = _props3.I18n,
        id = _props3.id,
        name = _props3.name,
        __onChange = _props3.onChange,
        onClick = _props3.onClick,
        readOnly = _props3.readOnly,
        size = _props3.size,
        textChecked = _props3.textChecked,
        textUnchecked = _props3.textUnchecked,
        use = _props3.use,
        rest = _objectWithoutProperties(_props3, ['checked', 'className', 'defaultChecked', 'disabled', 'I18n', 'id', 'name', 'onChange', 'onClick', 'readOnly', 'size', 'textChecked', 'textUnchecked', 'use']);

    var labelClassName = this.getLabelClassName({
      className: className,
      disabled: disabled,
      readOnly: readOnly,
      size: size,
      textChecked: textChecked,
      textUnchecked: textUnchecked,
      use: use
    });
    var switchClassName = this.getSwitchClassName();

    return _react2.default.createElement(
      'label',
      _extends({}, rest, { className: labelClassName }),
      _react2.default.createElement('input', _extends({ checked: checked, defaultChecked: defaultChecked, disabled: disabled, id: id, name: name, readOnly: readOnly }, {
        className: 'private-form__toggle-input sr-only',
        onChange: this.handleChange,
        onClick: onClick,
        ref: CHECKBOX_REF,
        type: 'checkbox'
      })),
      _react2.default.createElement(
        'span',
        { className: switchClassName, role: 'presentation' },
        this.renderToggleLabelChecked({ I18n: I18n, textChecked: textChecked }),
        _react2.default.createElement(
          'span',
          { className: 'private-form__toggle-switch__handle' },
          this.renderCheckedIndicator()
        ),
        this.renderToggleLabelUnchecked({ I18n: I18n, textUnchecked: textUnchecked })
      )
    );
  }
});

exports.default = (0, _Translatable2.default)(UIToggle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/input/UIToggle.js
// module id = 350
// module chunks = 0